<section class="formSection">
  <div class="ms-5 block">
    <div class="formContainer p-4 border-2 border-black">
      <h2 class="headingWL mb-3">Book a free<span> Session</span></h2>
      <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <input
            type="text"
            placeholder="Name"
            formControlName="name"
            class="formField"
            required
          />
          <div
            class="alertV"
            *ngIf="
              formGroup.get('name')?.hasError('required') &&
              formGroup.get('name')?.touched
            "
          >
            Name is required
          </div>
        </div>

        <div class="mobileFieldContainer d-flex gap-3 my-3">
          <select
            name="Gender"
            id="genreSelectionField"
            class="w-100 mt-3"
            formControlName="gender"
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <select
            name="Age Group"
            id="genreSelectionField"
            class="w-100 mt-3"
            formControlName="ageGroup"
          >
            <option value="">Select Your Age Group</option>
            <option value="6-12">6-12</option>
            <option value="13-21">13-21</option>
            <option value="22-35">22-35</option>
            <option value="35-50">35-50</option>
            <option value="50+">50+</option>
          </select>
        </div>
        <div class="d-flex flex-row gap-2">
          <div class="form-group w-100">
            <input
              type="email"
              placeholder="Email Address"
              formControlName="email"
              class="formField"
              required
            />
            <div
              class="alertV"
              *ngIf="
                formGroup.get('email')?.hasError('required') &&
                formGroup.get('email')?.touched
              "
            >
              Email is required
            </div>
            <div
              class="alertV"
              *ngIf="
                formGroup.get('email')?.hasError('email') &&
                formGroup.get('email')?.touched
              "
            >
              Invalid email format
            </div>
          </div>
          <div class="form-group w-100">
            <input
              type="tel"
              placeholder="Mobile Number"
              maxlength="10"
              formControlName="mobileNumber"
              class="formField"
              required
            />
          </div>
        </div>
        <div
          class="alertV"
          *ngIf="
            formGroup.get('mobileNumber')?.hasError('required') &&
            formGroup.get('mobileNumber')?.touched
          "
        >
          Mobile Number is required
        </div>
        <select
          name="genreSelection"
          id="genreSelectionField"
          class="w-100 mt-3"
          formControlName="genreSelection"
        >
          <option value="">Select Genre</option>
          <option value="Guitar" *ngFor="let item of genre">
            {{ item.genre }}
          </option>
        </select>

        <textarea
          class="comment mt-3 w-100 p-2"
          formControlName="comment"
          rows="3"
          placeholder="Comments"
        ></textarea>
        <div class="d-flex flex-row justify-content-end w-100">
          <button type="submit" class="submitBtn mt-3">SUBMIT</button>
        </div>
      </form>
    </div>
  </div>
</section>
